export default __webpack_public_path__ + "static/media/poster-sdg-12.c6991a05.png";